import { useMemo } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { useSavedTasks, useMyTagsForTasks, useAssigneeReadReceipts } from './api';
import TaskCard from './TaskCard';

export default function GuardadosPage() {
  const { profile } = useAuth();
  const { tasks, loading } = useSavedTasks(profile?.id);

  const taskIds = useMemo(() => tasks.map((t) => t.id), [tasks]);
  const { tagsByTask } = useMyTagsForTasks(taskIds, profile?.id);
  const receipts = useAssigneeReadReceipts(tasks, profile?.id);

  return (
    <div style={{ padding: '32px 40px', maxWidth: 920, margin: '0 auto' }}>
      <h1 style={{ fontSize: 26, fontWeight: 700, color: '#0f172a', margin: 0 }}>Guardados</h1>
      <p style={{ color: '#64748b', fontSize: 14, marginTop: 4, marginBottom: 24 }}>
        Los hilos que has marcado con la estrella.
      </p>

      {loading ? (
        <p style={{ color: '#94a3b8' }}>Cargando…</p>
      ) : tasks.length === 0 ? (
        <p style={{ color: '#94a3b8' }}>
          Aún no has guardado ningún hilo. Entra en cualquier hilo y pulsa ☆ para marcarlo.
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {tasks.map((t) => <TaskCard key={t.id} task={t} tags={tagsByTask[t.id]} readReceipt={receipts[t.id]} />)}
        </div>
      )}
    </div>
  );
}
